import { format as dateFNSFormat } from "date-fns";
import useTranslations from "../hooks/useTranslations";

export const TimeAgoKeys = [
  "today",
  "yesterday",
  "lastWeek",
  "lastMonth",
  "older",
];

export interface TimestampedObject {
  createdAt: string;
}

export interface TimeAgoSortedData<T> {
  today: T[];
  yesterday: T[];
  lastWeek: T[];
  lastMonth: T[];
  older: T[];
}

const today = new Date().setHours(0, 0, 0, 0);
const yesterday = today - 24 * 60 * 60 * 1000;
const oneWeekAgo = today - 7 * 24 * 60 * 60 * 1000;
const oneMonthAgo = today - 30 * 24 * 60 * 60 * 1000;

export function getTimeAgoGroups<T extends TimestampedObject>(
  data: T[]
): TimeAgoSortedData<T> {
  const sortedData: TimeAgoSortedData<T> = {
    today: [],
    yesterday: [],
    lastWeek: [],
    lastMonth: [],
    older: [],
  };

  data.forEach((e: T) => {
    if (new Date(e.createdAt).valueOf() >= today) {
      sortedData.today.push(e);
    } else if (new Date(e.createdAt).valueOf() >= yesterday) {
      sortedData.yesterday.push(e);
    } else if (new Date(e.createdAt).valueOf() >= oneWeekAgo) {
      sortedData.lastWeek.push(e);
    } else if (new Date(e.createdAt).valueOf() >= oneMonthAgo) {
      sortedData.lastMonth.push(e);
    } else {
      sortedData.older.push(e);
    }
  });

  return sortedData;
}

export function timeAgoLabel(time: string): string {
  const date = new Date(time);
  const rightNow = new Date();
  const t = useTranslations();

  if (date.valueOf() > today.valueOf()) {
    if (rightNow.valueOf() - date.valueOf() < 3600 * 1000) {
      const minutes = Math.floor(
        (rightNow.valueOf() - date.valueOf()) / 60 / 1000
      );
      return minutes === 0
        ? (t("activity.justNow") as string)
        : (t("activity.minutesAgo", {
            time: minutes,
          }) as string);
    } else {
      return t("activity.hoursAgo", {
        time: `${rightNow.getHours() - date.getHours()}`,
      }) as string;
    }
  } else if (date.valueOf() > oneMonthAgo.valueOf()) {
    return t("activity.daysAgo", {
      time: `${Math.ceil(
        (rightNow.valueOf() - date.valueOf()) / 24 / 3600 / 1000
      )}`,
    }) as string;
  } else {
    return dateFNSFormat(date, "MMMM d, yyyy");
  }
}
